import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';

const ConfirmationPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const orderId = state?.orderId;
  const totalAmount = state?.totalAmount;
  const paymentMethod = state?.paymentMethod;
  const paymentId = state?.paymentId;

  if (!orderId) {
    navigate('/');
    return null;
  }

  const isPaid = paymentMethod === 'online' && paymentId;

  return (
    <div className="page success-page">
      <div className="success-card">
        <div className="success-icon">{isPaid ? '✅' : '🎉'}</div>
        <h1>{isPaid ? 'Payment Successful!' : 'Order Placed!'}</h1>
        <p>
          {isPaid
            ? 'Your payment has been confirmed and your fresh produce will be delivered soon.'
            : 'Your fresh produce is confirmed and will be delivered to your apartment soon.'
          }
        </p>

        <div className="order-id-box">
          <div className="label">Your Order ID</div>
          <div className="value">#{orderId.slice(0, 8).toUpperCase()}</div>
          {totalAmount && <div style={{ fontSize: 14, color: 'var(--green-dark)', marginTop: 4, fontWeight: 600 }}>₹{parseFloat(totalAmount).toLocaleString('en-IN')}</div>}
        </div>

        {/* Payment status badge */}
        {paymentMethod === 'online' && (
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '6px 14px',
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 600,
            marginBottom: 16,
            background: '#dcfce7',
            color: '#166534',
            border: '1px solid #bbf7d0',
          }}>
            ✅ Paid via Razorpay
            {paymentId && <span style={{ fontSize: 11, opacity: 0.7 }}> · {paymentId.slice(-8)}</span>}
          </div>
        )}

        {paymentMethod === 'cod' && (
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '6px 14px',
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 600,
            marginBottom: 16,
            background: '#e0f2fe',
            color: '#075985',
            border: '1px solid #bae6fd',
          }}>
            💵 Cash on Delivery
          </div>
        )}

        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: 16, marginBottom: 24, textAlign: 'left' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--green-dark)', marginBottom: 10 }}>📋 What happens next?</div>
          {[
            { icon: '✅', text: 'Order received & confirmed' },
            { icon: '📦', text: 'Being packed by our team' },
            { icon: '🚚', text: 'Out for delivery to your apartment' },
            { icon: '🏠', text: 'Delivered to your door!' },
          ].map((step, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '5px 0', fontSize: 13 }}>
              <span>{step.icon}</span>
              <span style={{ color: 'var(--text-2)' }}>{step.text}</span>
            </div>
          ))}
        </div>

        <div className="success-actions">
          <Link
            to={`/track?orderId=${orderId}`}
            className="btn btn-green btn-full"
            style={{ padding: 14, fontSize: 15, borderRadius: 12 }}
          >
            📍 Track My Order
          </Link>
          <Link
            to="/"
            className="btn btn-light btn-full"
            style={{ padding: 14, fontSize: 15, borderRadius: 12 }}
          >
            🛒 Continue Shopping
          </Link>
        </div>

        <div style={{ marginTop: 20, fontSize: 12, color: 'var(--text-3)' }}>
          💡 Save your Order ID to track delivery status
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
